<template>
  <IonApp>
    <IonSplitPane content-id="main-content">
      <ion-menu content-id="main-content" type="overlay">
        <ion-content>
          <ion-list id="inbox-list">
            <ion-list-header>
              <ion-button
                @click="selectedIndex = -1"
                router-link="/"
                class="logo"
              >
                <ion-img :src="logoPath()"></ion-img>
              </ion-button>
            </ion-list-header>

            <ion-menu-toggle
              auto-hide="false"
              v-for="(p, i) in appPages"
              :key="i"
            >
              <ion-item
                @click="selectedIndex = i"
                router-direction="root"
                :router-link="p.url"
                lines="none"
                detail="false"
                class="hydrated"
                :class="{ selected: selectedIndex === i }"
              >
                <ion-icon slot="end" :ios="p.iosIcon" :md="p.mdIcon"></ion-icon>
                <ion-label>{{ p.title }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ion-list>
          <ion-list>
            <ion-item v-for="(b, i) in customizationButtons" :key="i">
              <ion-icon :ios="b.iosIcon" :md="b.mdIcon"></ion-icon>
              <ion-toggle
                @ionChange="b.method($event)"
                :checked="b.stateValue()"
              ></ion-toggle>
            </ion-item>
          </ion-list>
        </ion-content>
      </ion-menu>
      <ion-router-outlet id="main-content"></ion-router-outlet>
    </IonSplitPane>
  </IonApp>
</template>

<script lang="ts">
import {
  IonApp,
  IonButton,
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonToggle,
} from "@ionic/vue";
import { defineComponent, ref, watchEffect } from "vue";
import { globalStore } from "./store/global";
import { appPages, customizationButtons } from "@/data/menu";

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonButton,
    IonContent,
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonList,
    IonListHeader,
    IonMenu,
    IonMenuToggle,
    IonRouterOutlet,
    IonSplitPane,
    IonToggle,
  },
  setup() {
    const selectedIndex = ref(1);

    const path = window.location.pathname;
    if (path !== undefined) {
      selectedIndex.value = appPages.findIndex((page) =>
        path.startsWith(page.url)
      );
    }

    const logoPath = () => {
      return process.env.BASE_URL + "assets/icon/logo.png";
    };

    watchEffect(() => {
      document.body.classList.toggle("dark", globalStore.state.darkMode);
    });

    return {
      selectedIndex,
      appPages,
      customizationButtons,
      logoPath,
    };
  },
});
</script>

<style scoped>
ion-router-outlet {
  margin-top: var(--ion-safe-area-top);
  margin-right: var(--ion-safe-area-right);
  margin-bottom: var(--ion-safe-area-bottom);
  margin-left: var(--ion-safe-area-left);
}

ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;

  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;

  margin-bottom: 18px;

  color: #757575;

  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item:hover {
  --background: rgba(var(--ion-color-primary-rgb), 0.08);
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected:hover {
  --background: rgba(var(--ion-color-primary-rgb), 0.2);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-note {
  display: inline-block;
  font-size: 16px;

  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

.logo {
  height: 100%;
  color: var(--ion-item-background, var(--ion-background-color, #fff));
  --background-activated-opacity: 0;
  --background-hover-opacity: 0;
}
</style>